var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductCart = function SvgProductCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "#030F40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.5913 0 13.1174 0.632141 14.2426 1.75736C15.3679 2.88258 16 4.4087 16 6V7H20V9H18.833L18.076 18.083C18.0552 18.3329 17.9413 18.5658 17.7568 18.7357C17.5723 18.9055 17.3308 18.9999 17.08 19H2.92C2.66925 18.9999 2.4277 18.9055 2.24322 18.7357C2.05875 18.5658 1.94481 18.3329 1.924 18.083L1.166 9H0V7H4V6C4 4.4087 4.63214 2.88258 5.75736 1.75736C6.88258 0.632141 8.4087 0 10 0ZM16.826 9H3.173L3.84 17H16.159L16.826 9ZM11 11V15H9V11H11ZM7 11V15H5V11H7ZM15 11V15H13V11H15ZM10 2C8.97376 2 7.98677 2.39444 7.24319 3.10172C6.4996 3.80901 6.05631 4.77504 6.005 5.8L6 6V7H14V6C14 4.97376 13.6056 3.98677 12.8983 3.24319C12.191 2.4996 11.225 2.05631 10.2 2.005L10 2Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_cart.87777165.svg";
export { ForwardRef as ReactComponent };